import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-task-master',
  templateUrl: './task-master.component.html',
  styleUrls: ['./task-master.component.css']
})
export class TaskMasterComponent implements OnInit {

  data:any = []
  taskMasters:any = []
  singleTaskMasters:any = []
  cid:any

  searchKey: any = ""
  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;
  first: number = 0;

  isLoading: any = false

  actionControls: any = {
    isAdd: false, 
    isView: false, 
    isDelete: false, 
    isModify: false 
  }
  
  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  form: any | FormGroup
  
  ngOnInit(): void {
    let href:any = window.location.href;
    let messages = href.split('/') 
    let action: any = this.generic_service.checkActionControls(messages[messages.length-1])
    this.actionControls = action

    this.cid = sessionStorage.getItem('cid')
    // this.getAllTaskMasters()

    this.getAllTaskMasterWithPagination(this.pageNumber,this.recordsPerPage)


    this.form = this.fb.group({
      taskGroupName: [''],
      taskGroup: this.fb.array([])
    });
    this.addTaskGroup()
  }

  onTableDataChange(event: any) {

    this.pageNumber = event.page;

    if(this.searchKey != ""){
      this.getTaskMasterByWildSearch(this.pageNumber,this.recordsPerPage)
    }else{
      this.getAllTaskMasterWithPagination(this.pageNumber,this.recordsPerPage)
    }
  }

  get task(){
    return this.form.get('taskGroup') as FormArray;
  }

  taskGroupObject(){
    return this.fb.group({
      "seqNo": [''],
      "name": [''],
      "description": ['']
    })
   }
  
   addTaskGroup(){
    this.task.push(this.taskGroupObject())
   }

   removeTaskGroupObject(index: number){
    this.task.removeAt(index)
   }



  addTaskMaster(){
    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "taskSlNo": "",
      "taskGroupName": String(this.form.get('taskGroupName').value),
      "taskGroup": this.form.get('taskGroup').value,
      "cid": this.cid
    }
    console.log(body)
    this.generic_service.addTaskMaster(body).subscribe(
      (response:any)=>{
        console.log(response)
        this.toastr.success(response.message);
        this.cancelModel()
        this.getAllTaskMasters()
        this.form.reset()
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }
  
  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  getAllTaskMasters(){
    this.isLoading = false

    this.generic_service.getAllTaskMaster().subscribe(
      (response:any)=>{
        console.log(response)
        this.taskMasters = response.response
        this.totalRecords = response.response.length
        this.isLoading = false

      }
    )
  }

  getTaskMasterById(id:any){
    this.generic_service.getTaskMasterById(id).subscribe(
      (response:any)=>{
        console.log(response)
        this.singleTaskMasters = response.response.taskGroup
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }


  getAllTaskMasterWithPagination(pageNumber: any,recordsPerPage: any){
    this.isLoading = true

    this.generic_service.getAllTaskMasterWithPagination(pageNumber,recordsPerPage).subscribe(
      (response:any)=>{
        console.log(response)
        this.taskMasters = response.response.taskMasterList;
        this.totalRecords = response.response.totalRecords;
        this.isLoading = false

      }
    )
  }


  getTaskMasterByWildSearch(pageNumber: any,recordsPerPage: any){
    if(this.searchKey != ""){
      this.isLoading = true
  
      this.generic_service.getTaskMasterByWildSearch(this.searchKey,pageNumber,recordsPerPage).subscribe(
        (response:any)=>{
          console.log(response);
          this.taskMasters = response.response.taskMasterList;
          this.totalRecords = response.response.totalRecords;
          this.isLoading = false
  
        },
        (err:any)=>{
          console.log(err)
        }
      )
    }else{
      this.getAllTaskMasterWithPagination(this.pageNumber,this.recordsPerPage)
    }
  }
  
  refreshSearch(){
    this.searchKey = ""
    this.getAllTaskMasterWithPagination(this.pageNumber,this.recordsPerPage)
  }


}  